import React from "react";

function Article(props) {
    return (
        <div className={Article}>
            <h3>{props.name}</h3>
            <p>This Article is made as {props.name}'s description.</p>
        </div>
    )
}

export default Article;
